<template>
    <div>
        <ShippingLabelProductDialog
            :is-open="showProductDialog"
            :product-data="productDialogData.product"
            :is-editable="isEditable"
            :action="productDialogData.action"
            :products="products"
            @on-save="confirmChangeProduct"
            @on-close="closeShippingLabelProductDialog"
        />
        <v-dialog
            :value="isOpen"
            max-width="1100px"
            transition="slide-y-transition"
            eager
            @keydown.esc="onClose"
            @click:outside="onClose"
        >
            <v-card>
                <v-card-title>
                    <h1 class="text-subtitle-1">
                        Lista produktów
                    </h1>
                </v-card-title>
                <v-card-text>
                    <v-row justify="end" dense>
                        <v-col cols="12" sm="5" lg="4">
                            <v-text-field
                                v-model="search"
                                label="Produkt"
                                append-icon="mdi-magnify"
                                single-line
                                solo
                                hide-details
                                :disabled="products.length === 0"
                                clearable
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                v-model="selectedProducts"
                                :headers="headers"
                                :items="products"
                                dense
                                item-key="id"
                                sort-by="goodName"
                                :mobile-breakpoint="0"
                                name="productsData"
                                show-select
                                :items-per-page="5"
                                :page.sync="currentPaginationPage"
                                :search="search"
                                no-data-text="Brak danych"
                            >
                                <template #item.goodUnitPackageType="{item}">
                                    {{ item.goodUnitPackageType.name }}
                                </template>
                                <template #item.amount="{item}">
                                    <template v-if="item.goodUnitPackageTypeId === packageTypeWithoutSpecifiedCardbox">
                                        {{ item.goodUnitTargetInPackageSum }} / {{ availableGoodUnitTargetInPackageSum(item) }} szt
                                    </template>
                                    <template v-else>
                                        {{ item.goodUnitPackageQuantity }} / {{ availableAmount(item) }} opak
                                    </template>
                                </template>
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    v-if="editable(item)"
                                                    icon
                                                    data-sentry-label="Edytuj"
                                                    v-on="on"
                                                    @click="tryEdit(item)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="error"
                        text
                        data-sentry-label="Zamknij"
                        @click="onClose"
                    >
                        Anuluj
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="success"
                        text
                        data-sentry-label="Zapisz"
                        :disabled="selectedProducts.length === 0"
                        @click="onSave"
                    >
                        <template>
                            Zapisz
                        </template>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ShippingLabelProductDialog from './ShippingLabelProductDialog'
import tooltipDelay from '@/mixins/tooltip'


export default {
    name: 'ShippingLabelProductsDialog',
    components: {
        ShippingLabelProductDialog
    },
    mixins: [
        tooltipDelay
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        configurationProducts: {
            type: Array,
            default: () => []
        },
        goods: {
            type: Array,
            default: () => []
        },
        packageIndex: {
            type: Number,
            default: null
        },
        positionIndex: {
            type: Number,
            default: null
        },
        isEditable: {
            type: Boolean
        }
    },
    data() {
        return {
            shippingLabelProduct: {},
            selectedProducts: [],
            currentPaginationPage: null,
            search: null,
            showProductDialog: false,
            products: [],
            productDialogData: {
                product: {},
                availableProducts: [],
                action: null,
                onSave: () => {},
            },
            packageTypeWithoutSpecifiedCardbox: 49,
            headers: [
                {
                    text: 'Produkt',
                    sortable: false,
                    value: 'goodName',
                },
                {
                    text: 'Opakowanie',
                    sortable: false,
                    value: 'goodUnitPackageType',
                },
                {
                    text: 'W opakowaniu',
                    sortable: false,
                    value: 'goodUnitInPackageQuantity',
                    align: 'center'
                },
                {
                    text: 'Ilość',
                    sortable: false,
                    value: 'amount',
                    align: 'center'
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ],
        }
    },
    watch: {
        isOpen(value) {
            if (value) {
                this.products = JSON.parse(JSON.stringify(this.configurationProducts))
                this.products = this.products.filter(item => item.goodUnitPackageTypeId === this.packageTypeWithoutSpecifiedCardbox ? item.sourceGoodUnitTargetInPackageSum - item.assignedUnitTargetInPackageSumAmount !== 0 :
                    item.sourceGoodUnitPackageQuantity - item.assignedAmount !== 0)

                this.products = this.products.filter(product => !product.shippingPositionPackagesIndexes.some(item =>
                    item.addressIndex === this.positionIndex && item.packageIndex === this.packageIndex
                ))
            }
        }
    },
    methods: {
        editable(item) {
            return item.goodUnitPackageTypeId === this.packageTypeWithoutSpecifiedCardbox ? this.availableGoodUnitTargetInPackageSum(item) > 1 : this.availableAmount(item) > 1
        },
        tryEdit(item) {
            this.productDialogData.onSave = this.editProduct
            this.productDialogData.product = item
            this.productDialogData.action = 'add'
            this.productDialogData.availableProducts = this.products
            this.showProductDialog = true
        },
        closeShippingLabelProductDialog() {
            this.productDialogData.availableProducts = []
            this.showProductDialog = false
        },
        resetPagination() {
            this.currentPaginationPage = 1
        },
        availableAmount(product) {
            return product.sourceGoodUnitPackageQuantity - product.assignedAmount
        },
        availableGoodUnitTargetInPackageSum(product) {
            return product.sourceGoodUnitTargetInPackageSum - product.assignedUnitTargetInPackageSumAmount
        },
        confirmChangeProduct(product) {
            const index = this.products.findIndex(item => item.id === product.sourceConfigurationId)

            this.products.splice(index, 1, product)
            this.productDialogData.product = {}
            this.productDialogData.availableProducts = []
            this.updateSelectedProducts(product)
        },
        updateSelectedProducts(product) {
            const index = this.selectedProducts.findIndex(item => item.id === product.sourceConfigurationId)

            if (index > -1) {
                this.selectedProducts.splice(index, 1, product)
            } else {
                this.selectedProducts.push(product)
            }
        },
        onSave() {
            const selectedProducts = []

            this.selectedProducts.forEach(item => {
                const amount = item.goodUnitPackageTypeId === this.packageTypeWithoutSpecifiedCardbox ? parseInt(item.goodUnitTargetInPackageSum) :
                    parseInt(item.goodUnitInPackageQuantity) * parseInt(item.goodUnitPackageQuantity)

                const product = {
                    amount: amount,
                    goodCode: item.availableGoodCode,
                    goodId: item.availableGoodId,
                    good: item.availableGood,
                    goodName: item.goodName,
                    singleItemWeight: item.singleItemGoodWeight,
                    maxWeightCapacity: item.maxWeightCapacity,
                    setManuallyAmount: item.setManuallyAmount,
                    unitPackageHeight: item.goodUnitPackageHeight,
                    unitPackageLength: item.goodUnitPackageLength,
                    unitPackageQuantity: parseInt(item.goodUnitPackageQuantity),
                    unitPackageWeight: item.goodUnitPackageWeight,
                    unitPackageWidth: item.goodUnitPackageWidth,
                    sourceConfigurationId: item.id,
                    unitPackageTypeId: item.goodUnitPackageTypeId,
                    unitPackageType: item.goodUnitPackageType
                }

                selectedProducts.push(product)
            })
            this.$emit('on-save', JSON.parse(JSON.stringify(selectedProducts)), JSON.parse(JSON.stringify(this.selectedProducts)))
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.products = []
                this.selectedProducts = []
                this.resetPagination()
            }, 500)
        }
    }
}
</script>